<template>
    <select v-model="filter" name="filter" id="filter" class="form-select">
        <option value="">All</option>
        <option value="active">Active</option>
        <option value="draft">Draft</option>
        <option value="expired">Expired</option>
    </select>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
    defaultFilter: {
        type: String,
    },
})

const filter = ref(props.defaultFilter ?? '')

watch(filter, () => {
    if(filter.value == '') return window.location.assign(window.location.pathname)
    const params = new URLSearchParams({ filter: filter.value});
    window.location.search = params.toString()
})
</script>
